/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ClassModuleClassStudentViewModel } from "../types/ClassModuleClassStudentViewModel.ts";

export const classModuleClassStudentViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  name: z.string().nullish(),
}) as unknown as ToZod<ClassModuleClassStudentViewModel>;
